// Fase 3: clientes (perfil para o fit) e contatos. Dinheiro em centavos (Minor).
import { z } from 'zod';
import { UFS } from './editais';

export const PORTES = ['mei', 'me', 'epp', 'medio', 'grande'] as const;
export const PORTE_NOMES: Record<(typeof PORTES)[number], string> = {
  mei: 'MEI',
  me: 'Microempresa',
  epp: 'Empresa de pequeno porte',
  medio: 'Médio porte',
  grande: 'Grande porte',
};

const cnpj = z
  .string()
  .transform((v) => v.replace(/\D/g, ''))
  .pipe(z.string().length(14, 'CNPJ precisa ter 14 dígitos'));
const linhas = z.array(z.string().trim().min(1).max(500)).max(50);
const minor = z.number().int().nonnegative().nullable();

export const ContatoInput = z.object({
  nome: z.string().trim().min(2).max(120),
  email: z.string().trim().toLowerCase().email().max(200),
  recebeAlertas: z.boolean().default(true),
});

export const ClienteInput = z.object({
  razaoSocial: z.string().trim().min(2).max(200),
  nomeFantasia: z.string().trim().max(200).nullable().default(null),
  cnpj,
  porte: z.enum(PORTES),
  ufs: z.array(z.enum(UFS)).max(27).default([]),
  aceitaPresencial: z.boolean().default(false),
  cnaes: z
    .array(
      z
        .string()
        .transform((v) => v.replace(/\D/g, ''))
        .pipe(z.string().length(7)),
    )
    .max(30)
    .default([]),
  descricao: z.string().trim().min(20, 'Descreva o que a empresa vende (mínimo 20 caracteres)').max(4000),
  atestados: linhas.default([]),
  certificacoes: z.array(z.string().trim().min(1).max(120)).max(30).default([]),
  faturamentoAnualMinor: minor.default(null),
  valorMinimoMinor: minor.default(null),
  valorMaximoMinor: minor.default(null),
  evitar: z.array(z.string().trim().min(1).max(80)).max(50).default([]),
  ativo: z.boolean().default(true),
  contatos: z.array(ContatoInput).max(20).default([]),
});
export type ClienteInput = z.input<typeof ClienteInput>;

export const Contato = ContatoInput.extend({ id: z.string().uuid() });
export const Cliente = ClienteInput.omit({ contatos: true }).extend({
  id: z.string().uuid(),
  cnpj: z.string(),
  cnaes: z.array(z.string()),
  ufs: z.array(z.string()),
  contatos: z.array(Contato),
  createdAt: z.string(),
  updatedAt: z.string(),
  /** Contadores para a lista. */
  fits: z.object({ recomendados: z.number(), possiveis: z.number(), semTriagem: z.number() }),
  /** Pessoas com acesso ao app do cliente. */
  acessos: z.array(z.object({ userId: z.string(), nome: z.string(), email: z.string(), criadoEm: z.string() })),
});
export type Cliente = z.infer<typeof Cliente>;

export const ClientesResponse = z.object({ itens: z.array(Cliente) });
